// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"30":"1fcd4592590f2135","361":"5e29401c5aae98c3"}[chunkId] + ".css";
};